import React from "react";
import styled from "styled-components";
import AlertTitle from "@mui/material/AlertTitle/AlertTitle";
import { HtmlParseText, iTxt } from "@duosoftbg/nacid-components";
import { getI18n } from "react-i18next";
import { Alert } from "@mui/material";

const MessageSectionDelimiter = styled.div`
  margin-bottom: 15px;
`;

const PublicGlobalMessagesSection = ({ messages, severity, alertTitleColor }) => {
  return (
    <>
      {messages &&
        messages.map((message) => {
          return (
            <Alert key={message.id} severity={severity}>
              <AlertTitle style={{ color: alertTitleColor }}>
                <strong> {iTxt(getI18n().language, message.name, message.nameEn)}</strong>
              </AlertTitle>
              <div>
                <HtmlParseText
                  text={iTxt(getI18n().language, message.text, message.textEn)}
                  styleArray={{ pointerEvents: "none" }}
                />
              </div>
            </Alert>
          );
        })}

      {messages && <MessageSectionDelimiter />}
    </>
  );
};

export default PublicGlobalMessagesSection;
